import { useState } from "react"
import type { SleepSession } from "@/features/sleep/api/sleep.mutations"
import { SessionFormDialog } from "@/features/sleep/SessionFormDialog"
import { sleepTypeMeta } from "@/features/sleep/sleep.config"
import { formatClockRange, formatDuration } from "@/shared/utils/time"

export function SessionRow({ session }: { session: SleepSession }) {
  const [editing, setEditing] = useState(false)
  const meta = sleepTypeMeta(session.type)
  const Icon = meta.icon
  const ongoing = session.endTime === null

  return (
    <>
      <button
        type="button"
        onClick={() => setEditing(true)}
        className="flex w-full items-center gap-3 rounded-lg px-2 py-2 text-left transition-colors hover:bg-muted/50"
      >
        <Icon className="size-5 shrink-0 text-muted-foreground" />
        <div className="flex flex-1 flex-col">
          <span className="text-sm">{meta.label}</span>
          <span className="text-xs tabular-nums text-muted-foreground">
            {formatClockRange(
              new Date(session.startTime),
              ongoing ? null : new Date(session.endTime as string),
            )}
          </span>
        </div>
        {ongoing ? (
          <span className="flex items-center gap-1 text-xs text-accent">
            <span className="size-2 animate-pulse rounded-full bg-accent" />
            Pågår
          </span>
        ) : (
          session.durationMinutes !== null && (
            <span className="text-xs tabular-nums text-muted-foreground">
              {formatDuration(session.durationMinutes)}
            </span>
          )
        )}
      </button>
      <SessionFormDialog session={session} open={editing} onOpenChange={setEditing} />
    </>
  )
}
